import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const Overview = () => {
  const stats = [
    { label: 'Total Reach', value: '2.4M', change: '+18%', changeType: 'positive' },
    { label: 'Engagement Rate', value: '4.2%', change: '+0.8%', changeType: 'positive' },
    { label: 'Conversions', value: '1,247', change: '+23%', changeType: 'positive' },
    { label: 'ROI', value: '340%', change: '+45%', changeType: 'positive' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">Marketing Overview</h1>
        <p className="lm-page-subtitle">Performance summary across all channels</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">Channel Performance</h3>
          <Button variant="ghost" size="sm">View Details</Button>
        </div>
        <div className="lm-grid">
          {['Email', 'Social', 'Ads', 'Content'].map((channel) => (
            <div key={channel} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{channel}</span>
                <span className="lm-grid-card-badge" style={{ background: 'var(--success-soft)', color: 'var(--success)' }}>Active</span>
              </div>
              <div className="lm-grid-card-content">
                <p>Performance metrics for {channel.toLowerCase()} marketing channel</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Overview;
